import type { ProfileFormData } from './types';

const MIN_LENGTH = 20;
const MAX_LENGTH = 850;

interface Props {
  ownerName: string;
  data: ProfileFormData;
  onChange: (patch: Partial<ProfileFormData>) => void;
}

export function BuilderStep({ ownerName, data, onChange }: Props) {
  const length = data.bio.length;

  return (
    <div className="space-y-8">
      <h2 className="font-bold text-3xl">{ownerName}.builder?</h2>

      <div className="space-y-6 text-secondary-foreground">
        <p>
          cuéntanos lo más interesante que hayas{' '}
          <span className="text-foreground">
            creado, hackeado o experimentado
          </span>
          . idealmente relacionado con software / hardware, pero no exclusivo a
          eso.
        </p>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <textarea
            placeholder="construí temple os"
            value={data.bio}
            onChange={(e) => onChange({ bio: e.target.value })}
            className="min-h-[200px] w-full rounded border border-border bg-card px-4 py-3 text-foreground placeholder-secondary-foreground focus:border-primary focus:outline-none"
          />
          <div className="flex items-center justify-between text-xs">
            <div>
              {length > 0 && length < MIN_LENGTH && (
                <span className="text-secondary-foreground">
                  {MIN_LENGTH - length} characters needed
                </span>
              )}
              {length > MAX_LENGTH && (
                <span className="text-destructive">
                  Description is too long ({length}/{MAX_LENGTH})
                </span>
              )}
            </div>
            <span className="text-secondary-foreground">
              {length}/{MAX_LENGTH}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
